import search_CEP_Info from "../assets/js/main.js"

function SubmitBtn(){
    return (
        <button className='submit-btn' onClick={search_CEP_Info}>Search Info</button>
    )
}

export default SubmitBtn